module.exports = {
  steps: [
    {
      position: 1,
      name: 'ConfigAddress'
    },
    {
      position: 2,
      name: 'ConfigOpeningHours'
    },
    {
      position: 3,
      name: 'ConfigCapacity'
    },
    {
      position: 4,
      name: 'ConfigConfirmation'
    }
  ],
  days: [
    {
      label: 'Montag',
      name: 'Monday'
    },
    {
      label: 'Dienstag',
      name: 'Tuesday'
    },
    {
      label: 'Mittwoch',
      name: 'Wednesday'
    },
    {
      label: 'Donnerstag',
      name: 'Thursday'
    },
    {
      label: 'Freitag',
      name: 'Friday'
    },
    {
      label: 'Samstag',
      name: 'Saturday'
    },
    {
      label: 'Sonntag',
      name: 'Sunday'
    }
  ]
}
